{
  "REGISTER": {
    "TRY_WOOT": "Створити акаунт",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "Реєстрація",
    "TESTIMONIAL_HEADER": "Один крок і вперед",
    "TESTIMONIAL_CONTENT": "Ви за один крок від залучення своїх клієнтів, утримання їх та пошуку нових.",
    "TERMS_ACCEPT": "Зареєструвавшись, ви погоджуєтеся з нашими <a href=\"https://www.chatwoot.com/terms\">Умовами Користування</a> та <a href=\"https://www.chatwoot.com/privacy-policy\">Політикою конфіденційності</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Зареєструватися через Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Назва компанії",
      "PLACEHOLDER": "Введіть ім'я вашої компанії. Наприклад Wayne Enterprises",
      "ERROR": "Назва компанії закоротка."
    },
    "FULL_NAME": {
      "LABEL": "Повне ім'я",
      "PLACEHOLDER": "Введіть ваше повне ім'я. Наприклад Брюс Вейн",
      "ERROR": "Повне ім’я занадто коротке."
    },
    "EMAIL": {
      "LABEL": "Робоча електронна пошта",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Будь ласка, введіть робочу адресу електронної пошти."
    },
    "PASSWORD": {
      "LABEL": "Пароль",
      "PLACEHOLDER": "Пароль",
      "ERROR": "Пароль занадто короткий.",
      "IS_INVALID_PASSWORD": "Пароль повинен містити принаймні 1 велику літеру, хоча б 1 малу літеру, 1 цифру та 1 спеціальний символ.",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Підтвердити пароль",
      "PLACEHOLDER": "Підтвердити пароль",
      "ERROR": "Паролі не збігаються."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "Не вдалося підключитися до Woot сервера. Будь ласка, спробуйте ще раз."
    },
    "SUBMIT": "Створити акаунт",
    "HAVE_AN_ACCOUNT": "Вже маєте обліковий запис?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Повторно надіслати листа з підтвердженням",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
